runOnLoad "SubscriberExports", ["new", "create"], ->

  $(".export-option a.clear-action").click ->
    UI.setSelectValue($(this).closest(".form-field").find("select"), "")
    return false
